/**
 * Page affichée lorsque l'application est en mode maintenance.
 * Les utilisateurs sont redirigés vers cette page tant que le mode maintenance est actif.
 * @module pages/MaintenancePage
 */

import React, { useCallback, useState } from 'react';
import { isMaintenanceMode } from '../services/appConfigService';
import '../App.css';
import './MaintenancePage.css';

function MaintenancePage() {
  const [checking, setChecking] = useState(false);

  const handleRetry = useCallback(async () => {
    setChecking(true);
    try {
      const active = await isMaintenanceMode();
      if (!active) {
        window.location.reload();
      }
    } finally {
      setChecking(false);
    }
  }, []);

  return (
    <div className="maintenance-page">
      <div className="maintenance-card card">
        <div className="maintenance-icon" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>
        <h1 className="maintenance-title">Maintenance en cours</h1>
        <p className="maintenance-message">
          Nous effectuons des améliorations pour vous offrir une meilleure
          expérience. Nous serons de retour très bientôt.
        </p>
        <p className="maintenance-hint">
          Merci de votre patience.
        </p>
        <button
          className="button maintenance-retry-button"
          onClick={handleRetry}
          disabled={checking}
        >
          {checking ? 'Vérification...' : 'Réessayer'}
        </button>
      </div>
    </div>
  );
}

export default MaintenancePage;
